export const downloadCsv = (filename: string, text: string) => {
  const blob = new Blob([text], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const pom = document.createElement('a');
  pom.setAttribute('href', url);
  pom.setAttribute('download', filename);
  pom.click();
  URL.revokeObjectURL(url);
};

export const arrayBufferToBlob = (content: ArrayBuffer): Blob => {
  return new Blob([content], { type: 'application/pdf' });
};
